// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"pages-sponsorships-forms-sendEmailForm__inputContainer--2b-AW"};